let module = angular.module('capabilities', []);

// Keep this around for lifetime of window/application, regardless of
// angular service lifecycle.  Only export for testing purposes.
export var globalState = {
  account: null,
  reseller: null,
  capabilities: null,
  user: null,
};

export function Capabilities(Account, AccountReseller, User, UserCapabilities, $q) {
  'ngInject';

  // Wrap the loading in a basic promise API
  let promise;
  this.verifyResolved = () => promise;
  this.then = function (...args) {
    promise.then(...args);
  };

  // Expose helper methods
  this.canUserVisitState = (state) => {
    if (this.account.authorized()) {
      switch (state.name) {
        case 'channels':
          return this.user.can('update', 'channel/*');
        case 'settings.boxcasters':
        case 'settings.edit_boxcaster':
        case 'sources':
          return this.user.can('update', 'boxcaster/*');
        case 'settings.payment':
          return this.user.can('list', 'orders');
        case 'settings.api_keys':
          return this.user.can('create', 'api-key');
        case 'settings.integrations':
          return (
            this.user.can('list', 'facebook-users') ||
            this.user.can('list', 'twitter-users') ||
            this.user.can('list', 'vimeo-users') ||
            this.user.can('list', 'youtube-users') ||
            this.user.can('list', 'rtmp-push-channels') ||
            this.user.can('read', 'sportzcast-configuration')
          );
        case 'settings.storage':
          return (
            this.user.can('update', 'billing') &&
            this.user.can('list', 'storage-bills') &&
            (this.account.storage_policy == 'auto-bill' ||
              account.storage_policy == 'auto-delete') &&
            !this.account.feature_flags.no_viewers
          );
        case 'embed':
          return this.user.can('embed', 'broadcast/*');
        case 'reports.viewer':
          return this.user.can('read', 'viewer-analytics/*');
        case 'reports.tickets':
          return (
            this.user.can('read', 'viewer-analytics/*') &&
            this.user.can('read', 'broadcast/*:tickets:summary') &&
            this.user.can('read', 'channel/*:tickets:summary') &&
            this.user.can('read', 'tickets:summary')
          );
        case 'reports.donations':
          return (
            this.user.can('read', 'viewer-analytics/*') &&
            this.user.can('read', 'donations:summary')
          );
        case 'new-event':
          return this.user.can('create', 'broadcast');
        case 'uploads':
          return this.user.can('create', 'upload');
        case 'extended-test':
          return this.account.is_manufacturer;
        default:
          return true;
      }
    } else {
      switch (state.name) {
        case 'home':
        case 'logout':
        case 'settings.payment':
        case 'settings.upgrade':
        case 'checkout':
          return true;
        default:
          return false;
      }
    }
  };

  const init = (account, reseller, user, capabilities) => {
    // Turn the list of capabilities into a hash keyed by resource
    const capsByResource = {};
    capabilities.forEach((cap) => {
      const actions = capsByResource[cap.resource] || [];
      actions.push(...cap.actions);
      capsByResource[cap.resource] = actions;
    });

    // Configure the user with the list of capabilities. This lets its `can` and `cannot` methods work.
    user.configureCapabilities(capsByResource);
  };

  // Initialize with the account, capabilities, and user. Note that other services will ask for the
  // account and user, and use the capabilities via the user object.
  if (
    !globalState.account ||
    !globalState.reseller ||
    !globalState.user ||
    !globalState.capabilities
  ) {
    this.account = Account.get(() => {
      globalState.account = this.account;
    });
    this.reseller = AccountReseller.get();
    this.user = User.get(() => {
      globalState.user = this.user;
    });
    const capabilities = UserCapabilities.get();

    promise = $q
      .all([
        this.account.$promise,
        this.reseller.$promise,
        this.user.$promise,
        capabilities.$promise,
      ])
      .then(() => init(this.account, this.reseller, this.user, capabilities));
  } else {
    this.account = globalState.account;
    this.reseller = globalState.reseller;
    this.user = globalState.user;
    const capabilities = globalState.capabilities;
    promise = $q.all([
      this.account.$promise,
      this.reseller.$promise,
      this.user.$promise,
      capabilities.$promise,
    ]);
    init(this.account, this.reseller, this.user, capabilities);
  }
}

module.service('Capabilities', Capabilities);

export default module;



// WEBPACK FOOTER //
// ./app/services/capabilities.js